import {
  RESOURCE_MOBILIZATION_GET_URL,
  RESOURCE_MOBILIZATION_POST_URL
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

export const getResourceMobilization =
  associationsNum => (dispatch, getState) =>
    asyncRequest({
      url: RESOURCE_MOBILIZATION_GET_URL(associationsNum),
      successAction: data => ({
        type: types.GET_RESOURCE_MOBILIZATION_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.GET_RESOURCE_MOBILIZATION_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postResourceMobilization = payloadBody => (dispatch, getState) =>
  asyncRequest({
    url: RESOURCE_MOBILIZATION_POST_URL(),
    method: 'POST',
    data: payloadBody,
    successAction: data => ({
      type: types.POST_RESOURCE_MOBILIZATION_SUCCESS,
      async: true,
      payload: data,
      state: getState()
    }),
    failureAction: error => ({
      type: types.POST_RESOURCE_MOBILIZATION_FAILURE,
      payload: error
    }),
    dispatch
  });
export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
